import React from 'react'

interface SectionProps {
  children: React.ReactNode
  id?: string
  bg?: string
  maxWidth?: 'sm' | 'default'
  className?: string
}

const Section: React.FC<SectionProps> = ({ children, id, bg, maxWidth, className }) => {
  const containerWidth = maxWidth === 'sm' ? 'max-w-3xl' : 'max-w-7xl'

  return (
    <section id={id} className={`py-8 sm:py-16 lg:py-24 ${bg || ''} ${className || ''}`}>
      <div className={`${containerWidth} mx-auto px-4 sm:px-6 lg:px-8`}>
        {children}
      </div>
    </section>
  )
}

export default Section
